import { useContext } from "react"
import { DeveloperModeProvider } from "../components/DeveloperMode/DeveloperModeProvider"

export function useDeveloperMode() {
  const context = useContext(DeveloperModeProvider.context)

  if (!context) {
    throw new Error("useDeveloperMode must be used within a DeveloperModeProvider")
  }

  return context
}
